import thunk from 'redux-thunk';
import { applyMiddleware, createStore } from 'redux';
import header from './Header.reducer';

/**
 * @description It creates a Redux store that holds the complete state of app.
 * Redux Thunk middleware allows to make async actions.
 * @params
 *  - initialState - object
 * @return
 *  - store - object
 */
const configureStore = function () {
  let initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const createStoreWithMiddleware = applyMiddleware(thunk)(createStore);
  return createStoreWithMiddleware(header, initialState);
};
export default configureStore;